import styled from 'styled-components';
import CaplBackgroundImage from '../../assets/images/capl.png'

const PublicLayoutWrapper = styled.div`
  .layout {
    height: 100vh;
  }

  .main-img {
    background-image: url(${CaplBackgroundImage});
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
  }

  .main-content {
    background-color: white;
    padding: 70px 50px;
    text-align: center;
  }
`;

export default PublicLayoutWrapper;
